import React from "react";
import Header from "./header";
import Footer from "./footer";
import {
    Shield, Zap, TrendingUp, ArrowRight
} from 'lucide-react';

const ClientsPage = () => {
    // Unique clients (replace with your actual logos)
    const clients = [
        { id: 1, logo: "/WL.png" },
        { id: 2, logo: "/delloite.png" },
        { id: 3, logo: "/avenSprint.png" },
        { id: 4, logo: "/vc2.png" },
        { id: 5, logo: "/onePay.png" },
        { id: 6, logo: "/gramePay.png" },
        { id: 7, logo: "/blueStar.png" },
        { id: 8, logo: "/mumbaiPolice.png" },
        { id: 9, logo: "/saintGobain.png" },
        { id: 10, logo: "/serum.png" },
        { id: 11, logo: "/rtCom.png" },
        { id: 12, logo: "/aimil.png" },
        { id: 13, logo: "/x-Biz.png" },
    ];

    return (
        <div className="bg-gradient-to-b from-blue-50 to-indigo-50 text-gray-800 font-sans min-h-screen">
            {/* Header */}
            <div className="w-full shadow-md sticky top-0 z-50 bg-white">
                <Header />
            </div>

            {/* Main Content */}
            <div className="max-w-7xl mx-auto px-6 md:px-12 py-16">
                {/* Page Title */}
                <div className="text-center mb-12">
                    <h1 className="text-4xl md:text-5xl font-extrabold tracking-tight text-transparent bg-clip-text bg-gradient-to-r from-purple-600 to-pink-500">
                        Our Clients
                    </h1>
                    <p className="mt-3 text-lg md:text-xl text-gray-700 font-medium">
                        We are proud to collaborate with these amazing clients.
                    </p>
                </div>

                {/* Clients Grid */}
                <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 xl:grid-cols-4 gap-8 items-center justify-items-center">
                    {clients.map((client) => (
                        <div
                            key={client.id}
                            className="flex items-center justify-center bg-white rounded-2xl shadow-lg hover:shadow-xl transition transform hover:scale-105 p-6 w-full max-w-[220px] h-36"
                        >
                            <img
                                src={client.logo}
                                alt={`Client ${client.id}`}
                                className="h-20 md:h-24 object-contain"
                            />
                        </div>
                    ))}
                </div>
            </div>

            {/* CTA Section */}
            <section className="py-8 bg-gradient-to-br from-blue-600 via-indigo-600 to-purple-700 relative overflow-hidden">
                <div className="absolute inset-0 overflow-hidden pointer-events-none">
                    <div className="absolute top-10 left-10 w-32 h-32 bg-white/10 rounded-full animate-pulse"></div>
                    <div className="absolute top-40 right-20 w-24 h-24 bg-white/5 rounded-lg animate-bounce transform rotate-45" style={{ animationDelay: '1s' }}></div>
                    <div className="absolute bottom-20 left-20 w-16 h-16 bg-white/10 rounded-full animate-pulse" style={{ animationDelay: '2s' }}></div>
                    <div className="absolute bottom-40 right-10 w-20 h-20 bg-white/5 rounded-lg animate-bounce transform -rotate-12" style={{ animationDelay: '0.5s' }}></div>

                    <div className="absolute top-1/4 left-1/4 animate-float">
                        <Zap className="w-8 h-8 text-white/20" />
                    </div>
                    <div className="absolute top-1/3 right-1/3 animate-float" style={{ animationDelay: '1.5s' }}>
                        <Shield className="w-6 h-6 text-white/20" />
                    </div>
                    <div className="absolute bottom-1/3 left-1/3 animate-float" style={{ animationDelay: '3s' }}>
                        <TrendingUp className="w-7 h-7 text-white/20" />
                    </div>
                </div>

                <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10 text-center">
                    {/* Main Content */}
                    <div className="space-y-4 animate-fadeInUp">
                        <h2 className="text-2xl sm:text-4xl lg:text-4xl font-bold text-white leading-tight animate-slideInLeft">
                            Collaborating with the Best to Achieve More.
                        </h2>
                        {/* <p className="text-1xl sm:text-1xl lg:text-1xl text-blue-100">Get started with our comprehensive suite of business solutions today</p> */}
                    </div>

                    {/* CTA Button - Smaller and More Compact */}
                    <div className="mt-6 animate-fadeInUp" style={{ animationDelay: '1.2s' }}>
                        <button
                            className="group relative inline-flex items-center gap-3 bg-gradient-to-r from-white to-blue-50 text-blue-700 px-8 py-3 rounded-xl font-semibold text-lg hover:from-yellow-300 hover:to-orange-300 hover:text-gray-900 transform hover:scale-105 transition-all duration-500 shadow-xl hover:shadow-yellow-300/50"
                            onClick={() => {
                                window.location.href = '/contact';
                            }}
                        >
                            {/* <Play className="w-5 h-5 group-hover:animate-bounce" /> */}
                            <span>Get Started</span>
                            <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform duration-300" />

                            {/* Button Glow Effect */}
                            <div className="absolute inset-0 bg-gradient-to-r from-white/20 to-transparent rounded-xl opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>
                        </button>
                    </div>
                </div>

                <style jsx>{`
        @keyframes float {
          0%, 100% { transform: translateY(0px) rotate(0deg); }
          33% { transform: translateY(-10px) rotate(5deg); }
          66% { transform: translateY(5px) rotate(-5deg); }
        }
        
        @keyframes fadeInUp {
          from { opacity: 0; transform: translateY(30px); }
          to { opacity: 1; transform: translateY(0); }
        }
        
        @keyframes slideInLeft {
          from { opacity: 0; transform: translateX(-50px); }
          to { opacity: 1; transform: translateX(0); }
        }
        
        @keyframes slideInRight {
          from { opacity: 0; transform: translateX(50px); }
          to { opacity: 1; transform: translateX(0); }
        }
        
        @keyframes slideInUp {
          from { opacity: 0; transform: translateY(40px); }
          to { opacity: 1; transform: translateY(0); }
        }
        
        .animate-float {
          animation: float 4s ease-in-out infinite;
        }
        
        .animate-fadeInUp {
          animation: fadeInUp 0.8s ease-out forwards;
          opacity: 0;
        }
        
        .animate-slideInLeft {
          animation: slideInLeft 0.8s ease-out forwards;
          opacity: 0;
        }
        
        .animate-slideInRight {
          animation: slideInRight 0.8s ease-out forwards;
          opacity: 0;
        }
        
        .animate-slideInUp {
          animation: slideInUp 0.8s ease-out forwards;
          opacity: 0;
        }
      `}</style>
            </section>


            <Footer />
            <style jsx>{`
        @keyframes float {
          0%, 100% { transform: translateY(0px); }
          50% { transform: translateY(-10px); }
        }
        
        @keyframes fade-in-up {
          0% { opacity: 0; transform: translateY(30px); }
          100% { opacity: 1; transform: translateY(0); }
        }
        
        @keyframes fade-in-left {
          0% { opacity: 0; transform: translateX(-30px); }
          100% { opacity: 1; transform: translateX(0); }
        }
        
        @keyframes fade-in-right {
          0% { opacity: 0; transform: translateX(30px); }
          100% { opacity: 1; transform: translateX(0); }
        }
        
        @keyframes slide-in-left {
          0% { opacity: 0; transform: translateX(-20px); }
          100% { opacity: 1; transform: translateX(0); }
        }
        
        @keyframes slide-in-right {
          0% { opacity: 0; transform: translateX(20px); }
          100% { opacity: 1; transform: translateX(0); }
        }
        
        @keyframes bounce-slow {
          0%, 100% { transform: translateY(0); }
          50% { transform: translateY(-5px); }
        }
        
        .animate-float {
          animation: float 3s ease-in-out infinite;
        }
        
        .animate-fade-in-up {
          animation: fade-in-up 0.8s ease-out forwards;
        }
        
        .animate-fade-in-left {
          animation: fade-in-left 0.8s ease-out forwards;
        }
        
        .animate-fade-in-right {
          animation: fade-in-right 0.8s ease-out forwards;
        }
        
        .animate-slide-in-left {
          animation: slide-in-left 0.6s ease-out forwards;
        }
        
        .animate-slide-in-right {
          animation: slide-in-right 0.6s ease-out forwards;
        }
        
        .animate-bounce-slow {
          animation: bounce-slow 2s ease-in-out infinite;
        }
        
        .animation-delay-200 {
          animation-delay: 200ms;
        }
        
        .animation-delay-400 {
          animation-delay: 400ms;
        }
        
        .animation-delay-600 {
          animation-delay: 600ms;
        }
        
        .animation-delay-800 {
          animation-delay: 800ms;
        }
        
        .animation-delay-1000 {
          animation-delay: 1000ms;
        }
        
        .animation-delay-2000 {
          animation-delay: 2000ms;
        }
        
        .animation-delay-4000 {
          animation-delay: 4000ms;
        }
      `}</style>
        </div>
    );
};

export default ClientsPage;
